import { forwardRef, type ButtonHTMLAttributes } from "react";

import { cn } from "@/lib/cn";

interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Accessible name; icon-only buttons must always have one. */
  label: string;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { label, className, type = "button", ...props },
  ref,
) {
  return (
    <button
      ref={ref}
      type={type}
      aria-label={label}
      className={cn(
        "inline-flex size-control shrink-0 items-center justify-center rounded-control text-ink-muted",
        "transition-colors hover:bg-sunken hover:text-ink disabled:pointer-events-none disabled:opacity-50",
        className,
      )}
      {...props}
    />
  );
});
